// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2n1dU","buttons":"Footer_buttons__3QWhC"};